<template>
  <div class="grid pt4 grid-columns-3_lg">
    <form
      class="grid-column-span-2_lg subtle px2 py1 mt-margin"
      @submit.prevent="editRedFlag">
      <fieldset>
        <div class="align-right mt1"><button
          class="invisible-button mb0"
          @click.prevent="duplicate"><svg-duplicate/> Make a copy</button></div>
        <lw-text-input
          v-validate="'required'"
          :label="'Red flag'"
          :name="'title'"
          :type="'text'"
          :size="'large'"
          v-model="redFlag.title"
          :error="errors.first('title')"
        />
        <lw-textarea
          :label="'Description'"
          :name="'description'"
          :size="'large'"
          v-model="redFlag.description"
        />
        <div>
          <button
            v-shortkey="['meta', 's']"
            class="accent-button full-button_mb large-button mr1"
            type="submit"
            @shortkey="editRedFlag">Save</button>
          <button
            class="invisible-button negative-button"
            @click.prevent="cancel">Cancel</button>
          <button
            class="invisible-button negative-button right mt1"
            @click.prevent="isConfirming = true"><svg-archive/> Archive red flag</button>
        </div>
      </fieldset>
    </form>
    <app-archive-red-flag
      v-if="isConfirming"
      :name="redFlag.title"
      :page="page"
      :is-confirming.sync="isConfirming"/>
  </div>
</template>

<script>
import TextArea from '../livewires/TextArea'
import TextInput from '../livewires/TextInput'
import Archive from '../svgs/Archive'
import Duplicate from '../svgs/Duplicate'
import ArchiveRedFlag from './ArchiveRedFlag'

export default {
  components: {
    lwTextInput: TextInput,
    lwTextarea: TextArea,
    svgArchive: Archive,
    svgDuplicate: Duplicate,
    appArchiveRedFlag: ArchiveRedFlag
  },
  props: {
    rf: {
      type: Object,
      default: () => {}
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      redFlag: {},
      isConfirming: false
    }
  },
  mounted () {
    this.redFlag = this.rf
  },
  methods: {
    editRedFlag () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('saveState', false)
          let updatedFlag = { ...this.redFlag }
          updatedFlag.title = this.redFlag.title
          updatedFlag.id = this.$route.params.id
          updatedFlag.description = this.redFlag.description
          this.$store.dispatch('editRedFlag', updatedFlag)
          this.$emit('update:isEditing', false)
        }
      })
    },
    cancel () {
      this.$emit('update:isEditing', false)
    },
    duplicate () {
      this.$store.dispatch('toggleLoading', true)
      this.$store.dispatch('saveState', false)
      const payload = { ...this.redFlag }
      this.$store.dispatch('duplicateRedFlag', payload).then(response => {
        this.$router.push({ name: 'redflags' })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
